export const colorProfiles = {
  PURPLE: {
    LIGHT_PRIMARY: '#8729fd',
    DARK_PRIMARY: '#5e10bc',
    LIGHT_SECONDARY: '#eee1ff',
    DARK_SECONDARY: '#2c0c56',
    TEXT_PRIMARY: '#ffffff',
    LIGHT_TEXT_PRIMARY: '#2c0c56',
    LIGHT_TEXT_SECONDARY: '#758283',
    DARK_TEXT_SECONDARY: '#cad5e2',
    LIGHT_LINK_PRIMARY: '#6e00ff',
    DARK_LINK_PRIMARY: '#c697ff',
    DANGER: '#ff0000',
    SUCCESS: '#046A38',
    LIGHT_WHITE: '#ffffff',
  },
  ORANGE: {
    LIGHT_PRIMARY: '#ff8f00',
    DARK_PRIMARY: '#ff6f00',
    LIGHT_SECONDARY: '#ffffff',
    DARK_SECONDARY: '#913f00',
    TEXT_PRIMARY: '#ffffff',
    LIGHT_TEXT_PRIMARY: '#913f00',
    LIGHT_TEXT_SECONDARY: '#758283',
    DARK_TEXT_SECONDARY: '#cad5e2',
    LIGHT_LINK_PRIMARY: '#ffc107',
    DARK_LINK_PRIMARY: '#ffe082',
    DANGER: '#ff0000',
    SUCCESS: '#046A38',
    LIGHT_WHITE: '#ffffff',
  },
};

// NOTE: use "Color Highlight by Sergii N" extension in VS Code
// to get a better comparison at the colors being used
// for different modes & themes.
export const getColors = appColor => ({
  main: {
    LIGHT: colorProfiles[appColor].LIGHT_PRIMARY, // '#8729fd', '#ff8f00'
    DARK: colorProfiles[appColor].DARK_PRIMARY, // '#5e10bc', '#ff6f00'
  },
  bgColor: {
    // LIGHT: colorProfiles[appColor].LIGHT_SECONDARY, // '#eee1ff', '#ffffff'
    //Experimental change: making bgColor plain white in light mode
    LIGHT: colorProfiles[appColor].LIGHT_WHITE, // '#ffffff', '#ffffff'
    DARK: colorProfiles[appColor].DARK_SECONDARY, // '#2c0c56', '#913f00'
  },
  headerTitle: {
    LIGHT: colorProfiles[appColor].TEXT_PRIMARY, // '#ffffff', '#ffffff'
    DARK: colorProfiles[appColor].TEXT_PRIMARY, // '#ffffff', '#ffffff'
  },
  headerLogo: {
    LIGHT: colorProfiles[appColor].TEXT_PRIMARY, // '#ffffff', '#ffffff'
    DARK: colorProfiles[appColor].TEXT_PRIMARY, // '#ffffff', '#ffffff'
  },
  sideBarHeaderLogo: {
    LIGHT: colorProfiles[appColor].LIGHT_PRIMARY, // '#8729fd', '#ff8f00'
    DARK: colorProfiles[appColor].TEXT_PRIMARY, // '#ffffff', '#ffffff'
  },
  sideBarItemLogo: {
    LIGHT: colorProfiles[appColor].TEXT_PRIMARY, // '#ffffff', '#ffffff'
    DARK: colorProfiles[appColor].TEXT_PRIMARY, // '#ffffff', '#ffffff'
  },
  title: {
    LIGHT: colorProfiles[appColor].LIGHT_PRIMARY, // '#8729fd', '#ff8f00'
    DARK: colorProfiles[appColor].TEXT_PRIMARY, // '#ffffff', '#ffffff'
  },
  mdTitle: {
    LIGHT: colorProfiles[appColor].DARK_PRIMARY, // '#5e10bc', '#ff6f00'
    DARK: colorProfiles[appColor].TEXT_PRIMARY, // '#ffffff', '#ffffff'
  },
  text: {
    LIGHT: colorProfiles[appColor].LIGHT_TEXT_PRIMARY, // '#2c0c56', '#913f00'
    DARK: colorProfiles[appColor].TEXT_PRIMARY, // '#ffffff', '#ffffff'
  },
  placeHolderText: {
    LIGHT: colorProfiles[appColor].LIGHT_TEXT_SECONDARY, // '#758283', '#cad5e2'
    DARK: colorProfiles[appColor].DARK_TEXT_SECONDARY, // '#758283', '#cad5e2'
  },
  btnBgColor: {
    LIGHT: colorProfiles[appColor].TEXT_PRIMARY, // '#ffffff', '#ffffff'
    DARK: colorProfiles[appColor].DARK_SECONDARY, // '#2c0c56', '#913f00'
  },
  btnText: {
    LIGHT: colorProfiles[appColor].DARK_PRIMARY, // '#5e10bc', '#ff6f00'
    DARK: colorProfiles[appColor].TEXT_PRIMARY, // '#ffffff', '#ffffff'
  },
  border: {
    LIGHT: colorProfiles[appColor].DARK_PRIMARY, // '#5e10bc', '#ff6f00'
    DARK: colorProfiles[appColor].TEXT_PRIMARY, // '#ffffff', '#ffffff'
  },
  activeItem: {
    LIGHT: colorProfiles[appColor].DARK_PRIMARY, // '#5e10bc', '#ff6f00'
    DARK: colorProfiles[appColor].LIGHT_PRIMARY, // '#8729fd', '#ff8f00'
  },
  thumbColor: {
    LIGHT: colorProfiles[appColor].DARK_PRIMARY, // '#5e10bc', '#ff6f00'
    DARK: colorProfiles[appColor].LIGHT_PRIMARY, // '#8729fd', '#ff8f00'
  },
  trackColor: {
    LIGHT: colorProfiles[appColor].LIGHT_TEXT_SECONDARY, // '#758283', '#cad5e2'
    DARK: colorProfiles[appColor].DARK_TEXT_SECONDARY, // '#758283', '#cad5e2'
  },
  alertBg: {
    LIGHT: colorProfiles[appColor].LIGHT_SECONDARY, // '#eee1ff', '#ffffff'
    DARK: colorProfiles[appColor].DARK_SECONDARY, // '#2c0c56', '#913f00'
  },
  alertTitle: {
    LIGHT: colorProfiles[appColor].DARK_PRIMARY, // '#5e10bc', '#ff6f00'
    DARK: colorProfiles[appColor].TEXT_PRIMARY, // '#ffffff', '#ffffff'
  },
  alertMsg: {
    LIGHT: colorProfiles[appColor].DARK_PRIMARY, // '#5e10bc', '#ff6f00'
    DARK: colorProfiles[appColor].TEXT_PRIMARY, // '#ffffff', '#ffffff'
  },
  alertBtnBg: {
    LIGHT: colorProfiles[appColor].LIGHT_PRIMARY, // '#8729fd', '#ff8f00'
    DARK: colorProfiles[appColor].DARK_PRIMARY, // '#5e10bc', '#ff6f00'
  },
  alertBtnText: {
    LIGHT: colorProfiles[appColor].TEXT_PRIMARY, // '#ffffff', '#ffffff'
    DARK: colorProfiles[appColor].TEXT_PRIMARY, // '#ffffff', '#ffffff'
  },
  alertBorder: {
    LIGHT: colorProfiles[appColor].DARK_PRIMARY, // '#5e10bc', '#ff6f00'
    DARK: colorProfiles[appColor].TEXT_PRIMARY, // '#ffffff', '#ffffff'
  },
  linkColor: {
    LIGHT: colorProfiles[appColor].LIGHT_LINK_PRIMARY, // '#6e00ff', '#ffc107'
    DARK: colorProfiles[appColor].DARK_LINK_PRIMARY, // '#c697ff', '#ffe082'
  },
  cardBg: {
    LIGHT: colorProfiles[appColor].LIGHT_PRIMARY, // '#8729fd', '#ff8f00'
    DARK: colorProfiles[appColor].DARK_PRIMARY, // '#5e10bc', '#ff6f00'
  },
  cardText: {
    LIGHT: colorProfiles[appColor].TEXT_PRIMARY, // '#ffffff', '#ffffff'
    DARK: colorProfiles[appColor].TEXT_PRIMARY, // '#ffffff', '#ffffff'
  },
  inputView: {
    LIGHT: colorProfiles[appColor].TEXT_PRIMARY, // '#ffffff', '#ffffff'
    DARK: colorProfiles[appColor].DARK_SECONDARY, // '#2c0c56', '#913f00'
  },
  inputIcon: {
    LIGHT: colorProfiles[appColor].DARK_PRIMARY, // '#5e10bc', '#ff6f00'
    DARK: colorProfiles[appColor].TEXT_PRIMARY, // '#ffffff', '#ffffff'
  },
  inputText: {
    LIGHT: colorProfiles[appColor].DARK_PRIMARY, // '#5e10bc', '#ff6f00'
    DARK: colorProfiles[appColor].TEXT_PRIMARY, // '#ffffff', '#ffffff'
  },
  iconOnBgColor: {
    LIGHT: colorProfiles[appColor].TEXT_PRIMARY, // '#ffffff', '#ffffff'
    DARK: colorProfiles[appColor].TEXT_PRIMARY, // '#ffffff', '#ffffff'
  },
  dotZeroColor: {
    LIGHT: colorProfiles[appColor].LIGHT_SECONDARY, // '#eee1ff', '#ffffff'
    DARK: colorProfiles[appColor].DARK_SECONDARY, // '#2c0c56', '#913f00'
  },
  dotOneColor: {
    LIGHT: colorProfiles[appColor].DARK_PRIMARY, // '#5e10bc', '#ff6f00'
    DARK: colorProfiles[appColor].TEXT_PRIMARY, // '#ffffff', '#ffffff'
  },
  danger: {
    LIGHT: colorProfiles[appColor].DANGER, // '#ff0000', '#ff0000'
    DARK: colorProfiles[appColor].DANGER, // '#ff0000', '#ff0000'
  },
  dangerBtnText: {
    LIGHT: colorProfiles[appColor].TEXT_PRIMARY, // '#ffffff', '#ffffff'
    DARK: colorProfiles[appColor].TEXT_PRIMARY, // '#ffffff', '#ffffff'
  },
});
